import { Card } from "react-bootstrap";
import { Hr } from "../../../../_components/Abstractions/Hr/Hr";
import { BaseWastesForm } from "../../../../_components/Orders/WasteDetails/BaseWastesForm";
import { QuickWeighedWasteSelect } from "../../../../_components/Orders/ExternalWeighingTickets/QuickWeighedWasteSelect";

export function WeighbridgeTicketWasteDetailsForm({ ticketIndex, addressId, transactionType }) {
  const fieldName = `weighbridgeTickets[${ticketIndex}]`;
  const additionalFormControls = <div className="mb-2">
    <QuickWeighedWasteSelect wasteFieldName={fieldName} />
  </div>

  return (
    <Card className="mt-2">
      <Card.Body>
        <Hr>Towary przyjęte</Hr>
        <BaseWastesForm
          addressId={addressId}
          wasteFieldName={fieldName}
          isAddressIdRequired
          additionalFormControls={additionalFormControls}
          transactionType={transactionType}
          showExtendedView
          usedContainerFieldName="wasteExchange"
        />
      </Card.Body>
    </Card>
  );
}